export const sheetsExtensionTermsOfServiceData = [{
    header: "",
    content: 
            <div>
                <b>Last Updated:</b> May 07, 2026
            </div>
}, {
    header: "",
    content: 
            <div>
                Welcome to <b>Easy Image to Text</b>. By using our website, you agree to these Terms & Conditions. If you have any concerns, we recommend reviewing them before continuing to use our platform.
            </div>
}, {
    header: "Acceptance of Terms",
    content: 
            <div>
                By accessing or using <b>Easy Image to Text</b> or our Google Sheets extension <b>Convert PDF to Google Sheets™</b>, you acknowledge that you have read, understood, and agree to be bound by these terms. We reserve the right to update these terms at any time without prior notice. Your continued use of the service constitutes acceptance of any modifications.
            </div>
}, {
    header: "Use of the Service",
    content: 
            <ul>
                <li>
                    Easy Image to Text provides an <b>AI-powered OCR tool</b> for extracting text from images.
                </li>
                <li>
                    You may only use our platform through the provided interfaces. <b>Automated access via scripts, bots, or crawlers is prohibited</b>.
                </li>
                <li>
                    You must <b>not use the service for illegal, abusive, or harmful purposes</b>.
                </li>
                <li>
                    Users should not solely rely on the extracted text for legal, financial, or official purposes.
                </li>
                <li>We reserve the right to block or suspend access if misuse, abuse, or violations are detected.</li>
            </ul>
}, {
    header: "Fair Usage & Misuse Policy",
    content: 
            <ul>
                <li>
                    Users are expected to follow fair usage. Excessive or abnormal usage patterns may lead to account review.
                </li>
                <li>
                    Abuse, harassment, or threatening behavior toward the platform or support team is strictly prohibited.
                </li>
                <li>
                    Spamming, automated/bot access, or attempts to overload the system are considered misuse.
                </li>
                <li>
                    Reverse-engineering, tampering with the code, or any disruptive actions are forbidden.
                </li>
                <li>
                    Initiating chargebacks without first contacting support is treated as abuse.
                </li>
                <li>
                    We reserve the right to take appropriate action, including blocking access or reporting misconduct.
                </li>
            </ul>
}, {
    header: "Pricing & Feature Changes",
    content: 
            <div>
                We reserve the right to modify our pricing plans, usage limits, and feature availability at any time without prior notice. Continued use of the service constitutes acceptance of these changes.
            </div>
}, {
    header: "Uploaded Images & Data Handling",
    content: 
            <ul>
                <li>
                    Uploaded images are <b>processed temporarily and not stored</b> beyond the session.
                </li>
                <li>
                    We <b>do not share, sell, or distribute</b> any uploaded content.
                </li>
                <li>
                    All processing happens in real-time, and data is removed upon navigation or page refresh. 
                </li>
                <li>
                    Users <b>retain full ownership</b> of the content they upload, and responsible for ensuring privacy before uploading any content.
                </li>
                <li>
                    We <b>do not guarantee 100% accuracy</b> in OCR results, results may vary depending on image quality.
                </li>
            </ul>
}, {
    header: "Limitation of Liability",
    content: 
            <>
                <ul>
                    <li>
                        We provide the service <b>"as is" without warranties of any kind</b>.
                    </li>
                    <li>
                        We are <b>not responsible for any data loss, errors, or inaccuracies</b> resulting from using our service.
                    </li>
                    <li>
                        We <b>reserve the right to modify, suspend, or discontinue</b> any part of the service at any time.
                    </li>
                </ul>
            </>
}, {
    header: "Indemnification",
    content: 
            <div>
                By using this service, you agree to <b>indemnify and hold Easy Image to Text harmless</b> from any claims, damages, or losses arising from your use of the platform.
            </div>
}, {
    header: "Governing Law",
    content: 
            <ul>
                <li>
                    These Terms shall be governed by and construed in accordance with the laws of India. Any disputes shall be subject to the exclusive jurisdiction of the courts in India.
                </li>
                <li>
                    Easy Image to Text <b>operates under Indian law</b>. Users outside India are responsible for ensuring compliance with their local data regulations.
                </li>
                <li>
                    If you access this service from outside India, you do so at your own discretion and are responsible for ensuring    compliance with your local laws.
                </li>
            </ul>
}, {
    header: "Refund Policy for 'Convert PDF to Google Sheets™'",
    content: 
            <div>
                We offer a 3-day refund policy only for Subscription plans. If you're not satisfied with the service, you may request a full refund within 3 days of your purchase - no questions asked.
                To request a refund, contact us at: 📧 <span className="emailId">support@easyimagetotext.com</span>
            </div>
}, {
    header: "Changes to Terms",
    content: 
            <div>
                We may update these terms at any time. Any changes will be reflected on this page with the updated date. Continued use of the service after changes constitutes acceptance of the new terms.
            </div>
}, 
{
    header: <div><span style={{textDecoration: 'underline'}}>Legal Entity & Contact Information</span></div>,
    content:
            <div>
                <div className="mt-10"><b>Company Name:</b> Easy Image to Text (Government of India Registered Micro Enterprise)</div>
                <div className="mt-10"><b>Official Address:</b> Flat 2C, Daffodils Apartments, Block 63, Velachery Main Road, Rajakilpakkam, Chennai, Tamil Nadu - 600073, India.</div>
                <div className="mt-10"><b>Email:</b> support@easyimagetotext.com</div>
            </div>
}, 
{
    header: "Contact Us",
    content: 
            <div>
                For any questions regarding these Terms & Conditions, please contact us at: 📧 <span className="emailId">support@easyimagetotext.com</span>
            </div>
}, {
    header: "",
    content: 
            <div>
                By using <b>Easy Image to Text</b> or <b>Convert PDF to Google Sheets™</b>, you agree to these Terms and Conditions.
            </div>
}]